/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".parent[_ngcontent-%COMP%]   .logomain[_ngcontent-%COMP%]{box-shadow:0 1px 0 #4f4e4e}.sectbtn[_ngcontent-%COMP%]{color:#fff!important;background-color:#ed1976}.sectbtn[_ngcontent-%COMP%], .sectbtn[_ngcontent-%COMP%]:hover{border-color:#ed1976!important}.sectbtn[_ngcontent-%COMP%]:hover{color:#ed1976!important;background-color:transparent!important}"];
export { styles as styles };

